import tooltipCoverImage from './images/tooltipCoverImage.png';
import tooltipProfileBanner from './images/tooltipProfileBanner.png';
import tooltipIntroductionVideo from './images/tooltipIntroductionVideo.png';

import { Col, Row } from '@design-system/components/grid/grid';
import { Typography } from '@design-system/components/typography/typography';
import { sprinkles } from '@design-system/sprinkles.css';

type ImageTooltipProps = {
  lines: string[];
} & React.ImgHTMLAttributes<HTMLImageElement>;

export const ImageTooltip = ({ lines, ...p }: ImageTooltipProps) => (
  <Row
    gap="m"
    className={sprinkles({
      justifyContent: 'space-between',
      p: 'l',
      paddingBottom: '0',
    })}
  >
    <Col>
      {lines.map((l, i) => (
        <Typography variant={i === 0 ? 'bodyLarge' : 'body'} key={i}>
          {l}
        </Typography>
      ))}
    </Col>

    <Col style={{ width: `${p.width}px` }}>
      <img style={{ maxWidth: `${p.width}px` }} {...p} />
    </Col>
  </Row>
);

export const CoverImageTooltip = () => (
  <ImageTooltip
    lines={[
      'Cover Image',
      'Shown in Discovery section and will be displayed when users search for trainers.',
      'Make sure it represents you well and stands out!',
    ]}
    src={tooltipCoverImage}
    width={219}
    height={187}
  />
);

export const IntroductionVideoTooltip = () => (
  <ImageTooltip
    lines={[
      'Introduction video',
      'Displayed in the About section, use it to introduce yourself, share your background, and highlight your expertise.',
    ]}
    src={tooltipIntroductionVideo}
    width={201}
    height={159}
  />
);

export const ProfileBannerTooltip = () => (
  <ImageTooltip
    lines={[
      'Profile banner',
      'Displayed at the top of your profile, choose an eye-catching image that reflects your personality and style.',
    ]}
    src={tooltipProfileBanner}
    width={227}
    height={155}
  />
);
